/* NaturoBest bundle pages (NB4): scroll reveal and sticky CTA. */

(function () {
  'use strict';

  if (window.nb4Bundles) return;
  window.nb4Bundles = true;

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function each(root, selector, fn) {
    Array.prototype.forEach.call(root.querySelectorAll(selector), fn);
  }

  /* 1. Reveal on scroll ---------------------------------------------------- */
  var revealObserver = null;

  function initReveal(root) {
    if (!document.documentElement.hasAttribute('data-nb4-reveal')) return;
    if (reducedMotion() || (window.Shopify && window.Shopify.designMode)) return;
    if (typeof IntersectionObserver !== 'function') return;

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('nb4-reveal--in');
          revealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }

    var fold = window.innerHeight;

    each(root, '[data-nb4-reveal-group]', function (group) {
      if (group.dataset.nb4RevealReady) return;
      group.dataset.nb4RevealReady = 'true';

      Array.prototype.forEach.call(group.children, function (el, index) {
        if (el.getBoundingClientRect().top < fold) return;
        el.style.setProperty('--nb4-delay', Math.min(index % 4, 3) * 80 + 'ms');
        el.classList.add('nb4-reveal--armed');
        revealObserver.observe(el);
      });
    });
  }

  /* 2. Sticky CTA ---------------------------------------------------------- */

  /* Shown after the hero; hidden over the target and at the end of the page. */
  function initSticky(bar) {
    if (bar.dataset.nb4Ready) return;
    bar.dataset.nb4Ready = 'true';
    if (typeof IntersectionObserver !== 'function') return;

    var hero = document.querySelector('[data-nb4-sticky-trigger]');
    var targetId = (bar.getAttribute('data-nb4-sticky-target') || '').replace(/^#/, '');
    var target = targetId ? document.getElementById(targetId) : null;
    var sentinel = bar.parentNode.querySelector('[data-nb4-sticky-end]');

    var state = { pastHero: !hero, onTarget: false, atEnd: false };

    function sync() {
      var show = state.pastHero && !state.onTarget && !state.atEnd;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      // A hidden bar must not be reachable by keyboard.
      each(bar, 'a', function (a) {
        if (show) a.removeAttribute('tabindex');
        else a.setAttribute('tabindex', '-1');
      });
    }

    function watch(node, key, test) {
      if (!node) return;
      new IntersectionObserver(function (entries) {
        state[key] = test(entries[0]);
        sync();
      }).observe(node);
    }

    watch(hero, 'pastHero', function (e) {
      return !e.isIntersecting && e.boundingClientRect.top < 0;
    });
    watch(target, 'onTarget', function (e) { return e.isIntersecting; });
    watch(sentinel, 'atEnd', function (e) { return e.isIntersecting; });

    sync();
  }

  /* 3. Anchor links -------------------------------------------------------- */

  /* Scroll to #section links without adding the hash to the URL, so a refresh
     opens the page at the top. scroll-margin-top in the CSS clears the header. */
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('.nb4 a[href^="#"]');
    if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey) return;

    var id = link.getAttribute('href').slice(1);
    var target = id && document.getElementById(id);
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
  });

  /* Boot ------------------------------------------------------------------- */

  function init(root) {
    var scope = root || document;
    initReveal(scope);
    each(scope, '[data-nb4-sticky]', initSticky);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
